import OutboundLink from 'components/OutboundLink';
import './AcrisLinks.css';

/**
 * Opens the ACRIS document image viewer in a new tab.
 */
function AcrisImageLink(props) {
	const { text } = props;
	if (!text) {
		return '—';
	}

	return (
		<OutboundLink
			url={text}
			className="d-flex justify-content-center acris-image-link"
		>
			<i className="bi bi-image" title="View document image" />
		</OutboundLink>
	);
}

export default AcrisImageLink;
